import React, { Component } from 'react';
import FilterBasic from '../../../basicElement/FilterBasic';
import API_URL from '../../../../common/url';

class Filter extends Component {
    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '报价单号',
            key: 'quotationNum',
            type: 'input',
        }, {
            name: '服务类型',
            key: 'serverType',
            type: 'select',
            typeProperty: {
                list: [
                    { label: 'CRC服务', value: 'CRC服务' },
                ]
            }
        }, {
            name: '报价类型',
            key: 'quotationType',
            type: 'select',
            typeProperty: {
                list: [
                    { label: 'FTE制报价', value: 'FTE制报价' },
                ]
            }
        }, {
            name: 'Salesforce ID',
            key: 'salesforceId',
            type: 'input',
        }, {
            name: '是否已获得报价',
            key: 'haveQuotation',
            type: 'select',
            typeProperty: {
                list: [
                    { label: '是', value: '1' },
                    { label: '否', value: '0' },
                ]
            }
        }, {
            name: 'BA',
            key: 'ba',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 160},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: 'BD',
            key: 'bd',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 160},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '报价单状态',
            key: 'quotaionStatus',
            type: 'select',
            typeProperty: {
                style: { width: 160 },
                list: [
                    { label: '新建', value: '新建' },
                    { label: '待BDM合理性审批', value: '待BDM合理性审批' },
                    { label: 'BDM审批通过', value: 'BDM审批通过' },
                    { label: 'BDM审批不通过', value: 'BDM审批不通过' },
                    { label: '待BDO合理性审批', value: '待BDO合理性审批' },
                    { label: 'BDO审批通过', value: 'BDO审批通过' },
                    { label: 'BDO审批不通过', value: 'BDO审批不通过' },
                    { label: '客户同意报价', value: '客户同意报价' },
                    { label: 'BD已反馈修改意见', value: 'BD已反馈修改意见' },
                    { label: '根据审批意见修改中', value: '根据审批意见修改中' },
                    { label: '根据反馈意见修改中', value: '根据反馈意见修改中' },
                ]
            }
        }, {
            name: '审批人',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 160},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/quotation/list/Components/Filter.js